module.exports = __webpack_public_path__ + "img/private-pizzeriano3-pizzas.88be47ee.jpeg";